/* eslint-disable import/no-anonymous-default-export */
import { SET_FILTER, SET_ALL_FILTER } from './types';
import { get, set } from 'global/lib/lodash';
import { filterSyncScreens, screenFilterKeys, syncableFilterKeys } from 'global/utils/filter';

const removeUndefined = (obj) => {
  const newobj = {};
  for (let k in obj) {
    const val = obj[k];
    if (val !== undefined) {
      newobj[k] = val;
    }
  }
  return newobj;
};

const pickKeys = (obj, keys) => {
  const out = {};
  keys.forEach((k) => {
    if (obj[k] !== undefined) {
      out[k] = obj[k];
    }
  });
  return out;
};

export default function (filterType, filter, data) {
  return (dispatch, getState) => {
    const sState = getState();
    const screens = filterSyncScreens(filterType);

    // Not a tabbed sync category — update only the requested screen.
    if (!screens || screens.indexOf(filter) === -1) {
      dispatch({ type: SET_FILTER, filterType, filter, data });
      return;
    }

    // Source keeps only keys it owns (FILTERDEFAULTS). Siblings receive keys they
    // own that are present on the payload — not merely the intersection — so a
    // data-only key like `realms` can be seeded from Filters without sticking on list.
    screens.forEach((screen) => {
      const current = get(sState, `filter.${filterType}.${screen}`, {});
      const isSource = screen === filter;

      if (isSource) {
        const keys = screenFilterKeys(filterType, screen);
        set(sState, `filter.${filterType}.${screen}`, removeUndefined(pickKeys({ ...current, ...data }, keys)));
        return;
      }

      const keys = syncableFilterKeys(filterType, screen, data);
      if (!keys.length) {
        return;
      }

      set(
        sState,
        `filter.${filterType}.${screen}`,
        removeUndefined({
          ...current,
          ...pickKeys(data, keys),
        })
      );
    });

    dispatch({ type: SET_ALL_FILTER, data: get(sState, 'filter') });
  };
}
